module.exports = __webpack_public_path__ + "img/468x6O.d41d8cd9.svg";